; (function (jQuery) {

	"use strict";

	/**
	 * Allows the header desktop breakpoint to be filtered in child themes, default 1000px.
	 * Example filter usage:
	 *
	 * add_filter('bmgb_header_desktop_breakpoint', function () {
	 * 		return 1120;
	 * });
	 */
	function getHeaderDesktopBreakpoint() {
		var headerDesktopBreakpoint = window.BMBGThemeSettings && parseInt(window.BMBGThemeSettings.headerDesktopBreakpoint, 10);

		return !isNaN(headerDesktopBreakpoint) ? headerDesktopBreakpoint : 1000;
	}

	function Menu() {
		var global = {
			navExpanded: false,
			desktopBreakpoint: getHeaderDesktopBreakpoint(),
		};

		var fn = {
			init: function () {
				jQuery('.menu-toggle').on('click', fn.handleToggleBurgerMenu);
				jQuery('.primary-menu__submenu-toggle').on('click', fn.handleToggleSubmenu);
				fn.menuResetOnResize();
			},
			/**
			 * Reset the state of the menu when we change from desktop to mobile or vice versa
			 */
			menuResetOnResize: function () {
				var mediaQuery = window.matchMedia("(min-width: "+global.desktopBreakpoint+"px)");
				mediaQuery.addEventListener('change', function(){
					var mobileMenu = jQuery('.mobile-menu');
					var body = jQuery('body');
					var menuToggleButton = jQuery('.menu-toggle');
					var screenReaderText = jQuery('.menu-toggle .screen-reader-text');
					global.navExpanded = false;
					body.removeClass('mobile-menu-open');
					mobileMenu.removeClass('mobile-menu--open');
					menuToggleButton.attr('aria-expanded', 'false');
					menuToggleButton.removeClass('menu-toggle__menu-btn--active');
					jQuery('.primary-menu__item ').removeClass('submenu-open');
					screenReaderText.text('Menu');
				});
			},
			/**
			 * Make the chevron for sub-menus toggle a class to show/hide the submenu
			 * @param {*} e
			 */
			handleToggleSubmenu: function (e) {
				var $menuItem = jQuery(this).closest('.primary-menu__item');
				$menuItem.toggleClass('submenu-open');
				var $childrenMenuItem = $menuItem.find('.primary-menu__item');
				if ($childrenMenuItem.length) {
					$childrenMenuItem.removeClass('submenu-open');
				}
			},
			/**
			 * Controls behaviour of the burger toggle on mobile
			 *
			 * @param {*} e
			 */
			handleToggleBurgerMenu: function (e) {
				var mobileMenu = jQuery('.mobile-menu');
				var body = jQuery('body');
				var menuToggleButton = jQuery(this);
				var screenReaderText = jQuery('.menu-toggle .screen-reader-text');
				if (!global.navExpanded) {
					global.navExpanded = true;
					body.addClass('mobile-menu-open');
					mobileMenu.addClass('mobile-menu--open');
					menuToggleButton.attr('aria-expanded', 'true');
					menuToggleButton.addClass('menu-toggle__menu-btn--active');
					screenReaderText.text('Close menu');
				}
				else {
					global.navExpanded = false;
					body.removeClass('mobile-menu-open');
					mobileMenu.removeClass('mobile-menu--open');
					menuToggleButton.attr('aria-expanded', 'false');
					menuToggleButton.removeClass('menu-toggle__menu-btn--active');
					screenReaderText.text('Menu');
				}
			},
		}

		jQuery(fn.init);
	}

	new Menu();
})(jQuery);